<template>
    <div>
        <!-- BradCrumb header Start-->
        <section class="inner-header-bg">
            <div class="container">
                <!-- Breadcrumb Start-->
                <div class="section-breadcrumb">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-12 justify-content-center align-self-center pb-2">
                                <div class="breadcrumb-content">
                                    <div class="title-section">
                                        <h1 class="title text-center text-white">Contáctanos</h1>
                                    </div>
                                    <div class="breadcrumb-nav">
                                        <ul class="breadcrumb-link text-center list-unstyled mb-0">
                                            <li class="text-white"><a href="index.html">Inicio</a></li>
                                            <li class="text-white active">Contáctanos</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Breadcrumb End -->
            </div>
        </section>
        <!-- BradCrumb header End -->
        <!-- Google Map Section Start-->
        <div class="p-0">
            <div class="google-map" style="width:100%;">
                <!--<iframe src="https://maps.google.com/maps?q=manhatan&t=&z=13&ie=UTF8&iwloc=&output=embed" width="100" height="300" allowfullscreen></iframe>-->
                
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d233.3158034597655!2d-103.3594347115507!3d20.66742853440007!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8428ae01d275d5b5%3A0x10a404867277b156!2sAv%20Enrique%20D%C3%ADaz%20de%20Le%C3%B3n%20Sur%20596%2C%20Col%20Americana%2C%20Americana%2C%2044160%20Guadalajara%2C%20Jal.!5e0!3m2!1ses-419!2smx!4v1608177189425!5m2!1ses-419!2smx%22" width="600" height="450" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
            </div>
        </div>
        <!-- Google Map Section End-->
        <!-- Contact Section Start-->
        <section class="section section-contactus contactus-section">
            <div class="container">

                <div class="wow fadeIn" data-wow-delay="0.1s" data-wow-duration="1s">
                    <div class="title-section">
                        <div class="subtitle-hr d-flex align-items-center">
                            <h6 class="subtitle theme-color text-uppercase position-relative">Contacto</h6>
                            <hr>
                        </div>
                        <h2 class="title text-md-left text-center f-40">Ponte en contacto con nosotros</h2>
                    </div>
                    <div class="mt-4">
                        <div class="row">
                            <div class="col-sm-6 text-sm-left text-center">
                                <h6 class="green-color text-uppercase">Visita nuestra Oficina</h6>
                                <h3 class="text-dark res-h3-small">
                                    <a class="text-dark" href="https://www.google.com/maps" target="_blank">
                                        Enrique Díaz de León sur 596, Colonia Americana, Guadalajara Jal. 44190
                                    </a>
                                </h3>
                            </div>
                            <div class="col-sm-6 mt-sm-0 mt-4 text-sm-left text-center">
                                <h6 class="green-color text-uppercase">Envíanos un correo</h6>
                                <h3 class="text-dark res-h3-small">
                                    <a href="mailto:contact@wizrm.com" class="text-dark">
                                        contacto@wizrm.com
                                    </a>
                                    
                                </h3>
                            </div>
                        </div>
                    </div>
                    <form class="common-input-form mt-3" v-on:submit.prevent="submit">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input name="name" v-model="form.name" id="name" type="text" class="form-control border-0" placeholder="Nombre">
                                </div>
                                <div class="form-group">
                                    <input name="email" v-model="form.email" id="email" type="email" class="form-control border-0" placeholder="Correo">
                                </div>
                                <div class="form-group">
                                    <input name="subject" v-model="form.subject" id="subject" type="text" class="form-control border-0" placeholder="Asunto">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <textarea name="comments" v-model="form.message" id="comments" rows="2" class="form-control border-0" placeholder="Mensaje"></textarea>
                                </div>
                                <div class="form-group">
                                    <label for="robot" class="col-sm-2 col-form-label"></label>
                                    <div class="col-sm-10">
                                    <vue-recaptcha ref="recaptcha"
                                        @verify="onVerify" sitekey="6LeOWDwaAAAAAHdm1cQvbU8zj4-TzSrw9iGCVGxT">
                                        </vue-recaptcha>
                                    </div>
                                </div>
                            </div>
                        </div>                        
                        <div class="d-flex justify-content-end">
                            <button v-if="form.robot" type="submit" class="mt-2 btn theme-btn contact-form-btn border-0" value="Send">Enviar</button>
                        </div>
                    </form>
                </div>
            </div>
        </section>
        <!-- Contact Section End-->
    </div>
</template>
<script>
    //WOW JS
    import { WOW } from 'wowjs';
    import VueRecaptcha from 'vue-recaptcha';
    export default {
        name: 'contact',
        components: {
            VueRecaptcha
        },
        data(){
            return {
                form: {
                    name:'',
                    email: '',
                    subject: '',
                    message: '',
                    robot: false
                }
            }
        },
        mounted() {
            this.init();
        },
        methods: {
             submit(){  
                 if(this.form.robot){
                    fetch('https://hooks.slack.com/services/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', {
                        method: 'POST',
                        mode:'no-cors',
                        headers:{
                            'Content-type': 'application/json'
                        }, 
                        body: JSON.stringify({
                            "text": `--------------------------------\nName:${this.form.name}\nEmail:${this.form.email}\nSubject:${this.form.subject}\nMessage:${this.form.message}\n------------------------------------\n `
                        })
                    // eslint-disable-next-line no-unused-vars
                    }).then(res => {                    
                        this.form.name = ''
                        this.form.email = ''
                        this.form.subject = ''
                        this.form.message = ''
                    })
                    this.form.robot = false
                    this.$refs.recaptcha.reset();
                 }

            },
            onVerify(response){
                if(response) this.form.robot = true;
            },
            init() {
                this.initWowAnimation();              
            },
            /*----WOW ANIMATION-----*/
            initWowAnimation() {
                // eslint-disable-next-line no-undef
                var length = $('.wow').length;
                if (length >= 1) {
                    const wow = new WOW({
                        boxClass: 'wow',
                        animateClass: 'animated',
                        offset: 0,
                    });
                    wow.init();
                }
            } 
        }
    }
</script>